import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc, addDoc, collection, dateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { sendEmail } from "../components/sendemail";

export default function TutorProfile() {
  const { id } = useParams();
  const [tutor, setTutor] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);



  const [form, setForm] = useState({
    name: "",
    grade: "",
    subjects: "",
    availability: {},
    notes: ""
  });

  useEffect(() => {
    const fetchTutor = async () => {
      const snap = await getDoc(doc(db, "users", id));
      if (snap.exists()) setTutor(snap.data());
    };
    fetchTutor();
  }, [id]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

const submitRequest = async () => {

  // Save request to Firestore
  await addDoc(collection(db, "requests"), {
    tutorId: id,
    ...form,
    email: form.email,     
    pemail: form.pemail,
    createdAt: new Date()
  });

 await sendEmail(
      tutor.email,
      "You have a new tutoring request!",
      `<p>Hi ${tutor.name}!</p>
      <p>You have a new tutoring request from <strong>${form.name}</strong>.</p>
      <p>Log in to your dashboard to review and accept the request.</p>
      <p><a href="https://sow1-75bab.web.app/login">Click here to log in</a></p>
      <p>With Gratitude,<br/>SOWS</p>`
    );

    setShowForm(false);
    setSubmitted(true);
  };

  if (!tutor) return null;

  return (
    <>
  <div className="profile-container">

    <div className="profile-header">
      <h1>{tutor.name}</h1>
      <p>{tutor.schoolYear}</p>
    </div>

    <div className="profile-section">
      <h3>About</h3>
      <p>{tutor.bio}</p>
    </div>

    <div className="profile-section">
      <h3>Subjects</h3>
      <p>{Array.isArray(tutor.subjects) ? tutor.subjects.join(", ") : tutor.subjects}</p>
    </div>

<div className="profile-section availability-list">
  <h3>Availability</h3>

  {typeof tutor.availability === "string" && (
    <p>{tutor.availability}</p>
  )}

  {typeof tutor.availability === "object" &&
    tutor.availability !== null &&
    !Array.isArray(tutor.availability) &&
    Object.keys(tutor.availability).length > 0 &&

    Object.entries(tutor.availability).map(([day, times]) => (
      <p key={day}>
        <strong>{day}:</strong>{" "}
        {Array.isArray(times) ? times.join(", ") : times}
      </p>
    ))
  }
</div>

    <button
      className="request-btn"
      onClick={() => setShowForm(true)}
    >
      Request Tutor
    </button>

  </div>

  {/* ---------- REQUEST FORM POPUP ---------- */}

  {showForm && !submitted && (
    <div className="request-overlay">
      <div className="request-box">
<span 
  style={{
    position: "absolute",
    top: "20px",
    right: "25px",
    fontSize: "28px",
    cursor: "pointer"
  }}
  onClick={() => setShowForm(false)}
>
  ×
</span>

        <h2>Request Tutor</h2>

        <input
          name="name"
          placeholder="Student Name"
          onChange={handleChange}
        />

        <input
          name="grade"
          placeholder="Grade Level"
          onChange={handleChange}
        />

        <input
          name="subjects"
          placeholder="Subjects Needed"
          onChange={handleChange}
        />

        <input
          name="email"
          placeholder="Email Address"
          onChange={handleChange}
        />
<p style={{ fontSize: "17px", color: "gray", marginTop: "5px" }}>
  *For students under 18
</p>
        <input
          name="pemail"
          placeholder="Parent Email Address"
          onChange={handleChange}
        />

        <input
          name="availability"
          placeholder="Preferred Times"
          onChange={handleChange}
        />

        <textarea
          name="notes"
          placeholder="Additional Notes"
          rows="4"
          onChange={handleChange}
        />

        <button onClick={submitRequest}>
          Send Request
        </button>

      </div>
    </div>
    
  )}

  {/* ---------- CONFIRMATION SCREEN ---------- */}

  {submitted && (
    <div className="confirmation-box">
      <h2>Thank You for Your Request!</h2>
      <p>
        Your tutor should be in contact with you soon.
        <br /><br />
        If you haven’t heard back within a week, please contact us.
      </p>
    </div>
  )}
</>

  );
}
